<template>
    <UserPageLayout>
        <div class="max-w-md mx-auto pt-12">
            <div class="bg-white rounded shadow-lg px-5 py-6">
                <div class="text-center">
                    <i
                        :class="{
                            'far text-6xl': true,
                            'fa-check-circle text-green': status == 'success',
                            'fa-times-circle text-red': status == 'fail',
                            'far fa-hand-paper text-grey': status == 'cancel'
                        }"
                    ></i>
                </div>
                <div class="text-center">
                    <h1 v-if="status == 'success'" class="text-3xl shadow-text-none">
                        {{ $t('landing_subscription_thank') }}
                    </h1>
                    <h1 v-if="status == 'cancel'" class="text-3xl shadow-text-none">
                        {{ $t('landing_subscription_cancelled') }}
                    </h1>
                    <h1 v-if="status == 'fail'" class="text-3xl shadow-text-none">
                        {{ $t('landing_subscription_failed') }}
                    </h1>

                    <p class="pb-6">
                        <span class="shadow-text-none" v-if="status == 'success'">
                            {{ $t('landing_subscription_title_success') }} <br />
                            {{ $t('landing_subscription_title_success_2', { playerLimit }) }}
                        </span>
                        <span class="shadow-text-none" v-if="status == 'cancel'">{{
                            $t('landing_subscription_title_cancel')
                        }}</span>
                        <span class="shadow-text-none" v-if="status == 'fail'">{{
                            $t('landing_subscription_title_cancelled')
                        }}</span>
                    </p>
                </div>
                <div class="text-center mt-3">
                    <router-link
                        :to="{ name: 'my-quiz' }"
                        class="btn md:w-full block md:inline btn-lg text-xl uppercase font-opensans mb-1"
                        >{{ $t('landing_subscription_go_to_my_quiz') }}</router-link
                    >
                    <router-link
                        :to="{ name: 'order' }"
                        class="md:w-full block md:inline ml-0 md:ml-2 btn btn-lg text-xl uppercase font-opensans mb-1"
                        >{{ $t('landing_subscription_my_order') }}</router-link
                    >
                </div>
            </div>
        </div>
    </UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import appConfig from '@/app.config'
import Request from '@/lib/request'
import helper from '@/lib/helper.js'
import { currentUser } from '@/lib/user'

export default {
    components: {
        UserPageLayout
    },

    data() {
        return {
            playerLimit: ''
        }
    },

    created() {
        var request = new Request()

        if (window.location.search.length) {
            var params = {},
                query = window.location.search.replace(/\?/, '').split('&')

            query.forEach(function (q) {
                var param = q.split('=')
                params[param[0]] = param[1]
            })

            if (params['params']) {
                var resData = atob(decodeURIComponent(params['params']))
                resData = JSON.parse(resData)
                this.playerLimit = resData.p

                if (resData.subscribe_track != undefined) {
                    var payload = {
                        user: currentUser(),
                        subscribe_track: resData.subscribe_track
                    }

                    request.post(appConfig.api.stripeCreateSubscriptionOrder, payload)
                }
            }

            if (params['mt']) {
                this.trackPay(params['mt'])
            }
        }
    },

    computed: {
        status() {
            return this.$route.params.status
        }
    },

    methods: {
        trackPay(payment) {

            const payments = {
                pp: 'PayPal',
                st: 'Stripe',
                vp: 'Vipps'
            }

            const fullPaymentName = payments[payment] || 'Unknown'

            helper.gTrackEvent('payed', {
                event_category: `Payed_${fullPaymentName}`,
                event_label: 'Pay_subscribe'
            })
        },
    }
}
</script>
